import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './CheckmarkIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const CheckmarkIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function CheckmarkIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 22 22" component={Icon} {...props} />
  );
});
